import controller from './filter-module-multi-controller';

const FilterModuleMultiComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    filter: '<',
    filterOpts: '<',
    searchMin: '<',
    fullNameTooltip: '<',
    onSelection: '&?',
    vizFilter: '<',
  },
  template: `
    <div class="filter-module-multi">

      <!-- Option Filter Begins -->
      <div class="filter-module-search-container" ng-if="ctrl.minimumOptionsAvailable()">
        <input type="text"
               class="form-control form-control-sm form-control-block"
               ng-model="ctrl.filterPattern"
               ng-model-options="{ debounce: 200 }"
               placeholder="Find..." />
      </div>
      <!-- @Option Filter Ends -->

      <div class="field-group">

        <!-- List Item Begins -->
        <span ng-if="ctrl.isAllSelectable" class="checkbox-icon option-field">
          <input
            id="filter-select-all-{{ctrl.position}}"
            name="Select All"
            type="checkbox"
            value="Select All"
            ng-model="ctrl.selectAll"
            ng-class="{'partially-selected': ctrl.isPartiallySelected()}"
            />
          <label class="option-label inline-icon icon-editor-checkbox-light-unchecked" for="filter-select-all-{{ctrl.position}}">
            <span>(Select All)</span>
          </label>
        </span>

        <span ng-repeat="option in ctrl.options | filter:{ label: ctrl.filterPattern } | limitTo: 250 track by $index">

          <!-- Multiple Selection Item Iterator Begins -->
          <span class="checkbox-icon option-field">
            <input
              id="filter-{{ctrl.position}}-{{$index}}"
              name="{{option.value}}"
              type="checkbox"
              value="{{option.value}}"
              ng-checked="ctrl.isSelected(option.value)"
              ng-click="ctrl.toggleSelection(option.value, $event.target.checked)"
              />
            <label class="option-label inline-icon icon-editor-checkbox-light-unchecked" for="filter-{{ctrl.position}}-{{$index}}">
              <span
                ng-class="{'null-option': option.value === null, 'excluded-option': ctrl.isSelected(option.value) && ctrl.excludeValues}"
                ng-attr-uib-tooltip="{{ctrl.fullNameTooltip ? option.label : undefined}}"
                ng-attr-tooltip-placement="{{ctrl.fullNameTooltip ? 'left' : undefined}}"
                ng-attr-tooltip-append-to-body="{{ctrl.fullNameTooltip ? true : undefined}}"
                ng-attr-tooltip-class="wrapping-tooltip-lg"
                tooltip-popup-delay="250"
              >
                {{option.label}}
              </span>
            </label>
          </span>
          <!-- @Multiple Selection Item Iterator Ends -->

        </span>
        <!-- @List Item Ends -->

      </div>
      <div ng-if="ctrl.vizFilter" class="filter-module-exclude-values pull-right">
        <span class="exclude-values-label">Exclude selected values</span>
        <mode-toggle-switch
          [state]="ctrl.excludeValues"
          (state-change)="ctrl.toggleExcludeValues($event)"
          data-test="toggle-external-sharing"
        ></mode-toggle-switch>
      </div>
    </div>
  `,
};

export { FilterModuleMultiComponent };
